// @zzyonbr/torre-shared · entry barrel
export * from './auth.js';
export * from './tenant.js';
export * from './theme.js';
export * from './http.js';
export * from './utils.js';

// Web components — side-effect imports (registram custom elements)
import './components/zzy-logo.js';
import './components/zzy-header.js';
import './components/zzy-sidebar.js';
import './components/zzy-stat-card.js';
import './components/zzy-toast.js';
import './components/zzy-spinner.js';
import './components/zzy-empty.js';
import './components/zzy-feature-gate.js';

// Inject base CSS (tokens) automatically
import { injectBaseStyles } from './theme.js';
injectBaseStyles();
